module.exports = __webpack_public_path__ + "img/ip-top@2x.11f53ddf.png";